import React from "react";

export default function SignOut() {
    return (
        <div>
            <div><h5>You have been logged out.</h5></div>
        </div>
    );
}
